// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';

import ModuleTabbedCarousel from '../views';

const ABTestVariationCheck = 'ab_test';

const getCategoriesList = (props) => {
  const { variation, ...otherProps } = props;
  if (variation !== ABTestVariationCheck) return [];

  return Object.entries(otherProps)
    .filter(([key]) => key.match(/(CATKEY[0-9])/g))
    .map(([, value]) => ({ label: value, id: value }));
};

const mapStateToProps = (state, ownProps) => {
  return {
    categoriesList: getCategoriesList(ownProps),
  };
};

const ModuleTabbedCarouselContainer = connect(mapStateToProps)(ModuleTabbedCarousel);

export default ModuleTabbedCarouselContainer;
